//
// Copyright (c) 2011 - 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').service('ProductSearchService', [
    'rx',
    'AssistedProductTaggingService',
    'PRODUCT_RESULTS_TYPES',
    function(
            rx,
            AssistedProductTaggingService,
            PRODUCT_RESULTS_TYPES,
        ) {
      const self = this;

      const initialProductsState = {
        productsList: [],
        resultsType: null,
      };

      const productsState = new rx.ReplaySubject(1);
      self.getProductsState = function() {
        return productsState.asObservable();
      };

      self.getProductSuggestions = function(universalItemId, boxId) {
        const cachedBoundingBox = AssistedProductTaggingService.getCachedBoundingBox(universalItemId, boxId);
        productsState.next({
          productsList: _(cachedBoundingBox.topProductMatches).pluck('product'),
          resultsType: PRODUCT_RESULTS_TYPES.CATALOG_SUGGESTIONS,
        });
      };

      self.handleSearchResults = function(products) {
        if (products.length === 0) {
          productsState.next({
            productsList: [],
            resultsType: PRODUCT_RESULTS_TYPES.NO_RESULTS,
          });
        } else if (products[0].productType && products[0].productType === 'Crawl') {
          productsState.next({
            productsList: products,
            resultsType: PRODUCT_RESULTS_TYPES.CRAWL_RESULT,
          });
        } else {
          productsState.next({
            productsList: products,
            resultsType: PRODUCT_RESULTS_TYPES.CATALOG_RESULTS,
          });
        }
      };

      self.handleNoCatalog = function() {
        productsState.next({
          productsList: [],
          resultsType: PRODUCT_RESULTS_TYPES.NO_CATALOG,
        });
      };

      self.clearProductsState = function() {
        productsState.next(initialProductsState);
      };
    },
  ]);
})();
